export type UserRole = string;

export const UserRole = {
	SuperAdmin: 'Super_Admin',

	ApimAdmin: 'APIM_Admin',

	ApprovalsViewer: 'Approvals_Viewer',

	CloudAccountAdmin: 'CloudAccount_Admin',

	CloudGroupAdmin: 'Cloud_Group_Admin',

	DisconnectedSubscriptionRequestor: 'Disconnected_Subscription_Requestor',
	SubscriptionRequestor: 'Subscription_Requestor',
	SubscriptionAdmin: 'Subscription_Admin',
	SubscriptionTechnicalReviewer: 'Subscription_Technical_Reviewer',
	ConnSubUser: 'Conn_Sub_User',

	AWSAccountAdmin: 'AWS_Account_Admin',
	AWSDisconnectedAccountRequestor: 'AWS_Disconnected_Account_Requestor',
	AWSManagedAccountRequestor: 'AWS_Managed_Account_Requestor',
	AWSPlatformDeliveryArchitect: 'AWS_Platform_Delivery_Architect',
	AWSPlatformArchitect: 'AWS_Platform_Architect',
	AWSConnectivityTechnicalImplementor: 'AWS_Connectivity_Technical_Implementor',
	AWSAccountTechnicalImplementor: 'AWS_Account_Technical_Implementor',
	AWSPrivilegedDisconnectedAccountRequestor: 'AWS_Privileged_Disconnected_Account_Requestor',
	AWSAccountOwner: 'AWS_Account_Owner',
	AWSAccountCustodian: 'AWS_Account_Custodian',
	AWSAccountGroupsApprover: 'AWS_Account_Groups_Approver',
	AWSAccountCancellor: 'AWS_Accounts_Cancelor',
	AWSAccountTier0Approver: 'AWS_Account_Tier0_Approver',
	AWSAccountVaultApprover: 'AWS_Account_Vault_Approver',



	PORReader: 'POR_Reader',
	SubToOnPremTechnicalReviewer: 'POR_SubToOnPrem_Technical_Reviewer',
	SubToInternetTechnicalReviewer: 'POR_SubToInternet_Technical_Reviewer',
	PORSubToInternetSolArqReviewer: "POR_SubToInternet_Sol_Arq_Reviewer",
	PORSubToInternetCyberReviewer: "POR_SubToInternet_Cyber_Reviewer",
	PORSubToOnPremSolArqReviewer: "POR_SubToOnPrem_Sol_Arq_Reviewer",
	PORSubToOnPremCyberReviewer: "POR_SubToOnPrem_Cyber_Reviewer",
	
	DNDRSubToInternetTechnicalReviewer: 'DNDR_SubToInternet_Technical_Reviewer',
	DNDRSubToInternetGatewayPolicyReviewer: 'DNDR_SubToInternet_GatewayPolicy_Reviewer',
	DNDRSubToInternetCyberReviewer: 'DNDR_SubToInternet_Cyber_Reviewer',
	// DNDRTechnicalReviewer: 'DNDR_Technical_Reviewer',
	DNDRTechnicalImplementer: 'DNDR_Technical_Implementer',
	DNDRNetSecReviewer: "DNDR_NetSec_Reviewer",
	DNDRReader: 'DNDR_Reader',
	DNDAdmin: 'DND_Admin',

	AWSPORReader: 'AWS_POR_Reader',
	AWSPORTechnicalImplementer: 'AWS_POR_Technical_Implementer',
	AWSPORCyberReviewer: 'AWS_POR_Cyber_Reviewer',
	AWSPORSolArqReviewer: 'AWS_POR_Sol_Arq_Reviewer',
	AWSPORTechnicalReviewer: 'AWS_POR_Technical_Reviewer',

	AWSSSORequestor: 'AWS_SSO_Requestor',

	ReportingUser: 'Reporting_User',

	CapabilityManager: 'Capability_Manager',

	SSPDeveloper: 'SSP_Developer',
	
	OrgAdmins: 'Org_Admins',

	ADAppsUser: 'AD_Apps_User',

	TAPReportUser:'TAP_Report_User',

	PORToOnPremTechReviewer: 'POR_On-Prem_Technical_Reviewer',
	PORToOnPremTechImplementer: 'POR_On-Prem_Technical_Implementer',
	PORToOnPremOTCRM: 'POR_On-Prem_OTCRM',
	POROnPremSolArqReviewer: 'POR_On-Prem_Sol_Arq_Reviewer',
	PORToOnPremCyberReviewer: 'POR_On-Prem_Cyber_Reviewer',
	POROnPremProxyArchitectReviewer: 'POR_On-Prem_Proxy_Architect_Reviewer',
	POROnPremIBossTechnicalImplementer: 'POR_On-Prem_IBoss_Technical_Implementer',
	POROnPremReader: 'POR_On-Prem_Reader',
	POROnPremRequestor: 'POR_On-Prem_Requestor',
	POROnPremS2SVPNImplementor:'POR_On-Prem_S2S_VPN_Implementor',

	PolicyExemptionASAApprover: "PolicyExemption_ASA_Approver",
	PolicyExemptionCSCApprover: "PolicyExemption_CSC_Approver",
	PolicyExemptionCyberApprover: "PolicyExemption_Cyber_Approver",
	PolicyExemptionIAApprover: "PolicyExemption_IA_Approver",
	PolicyExemptionAVDApprover: "PolicyExemption_AVD_Approver",
	PolicyExemptionAKSACIApprover: "PolicyExemption_AKSACI_Approver",
	PolicyExemptionDataIntegrationApprover: "Policy_Exemption_DIITA_Approver",
};
